import { FieldMap } from '../../types/forms/fields'
import { InsuranceInfo } from '../../types/users/user'
import { FieldMapValue } from '../../types/utils/common'
import { getHasPrimaryCoverage, getHasSecondaryCoverage } from '../../utils/assessments/coverage'
import { getInsuranceCoverageField } from '../insurance/insuranceCoverage'

export const getPregnancySecondaryCoverageField = (
  insuranceInfo: FieldMapValue | undefined,
  admin: boolean,
  withCallIn: boolean,
): FieldMap | null => {
  // const insuranceInfo = data?.insuranceInfo
  const hasSecondaryCoverage = getHasSecondaryCoverage(insuranceInfo ?? {})
  if (!hasSecondaryCoverage) return null
  const baseField = getInsuranceCoverageField(
    !!insuranceInfo?.secondaryCoverage?.isMedicaid,
    withCallIn,
    true,
    admin,
  )
  return {
    ...baseField,
    name: 'Secondary Coverage',
  }
}

export const getPregnancyPrimaryCoverageField = (
  insuranceInfo: Partial<InsuranceInfo> | undefined,
  admin: boolean,
  withCallIn: boolean,
): FieldMap | null => {
  const hasPrimaryCoverage = getHasPrimaryCoverage(insuranceInfo ?? {})
  if (!hasPrimaryCoverage) return null
  return {
    ...getInsuranceCoverageField(
      !!insuranceInfo?.primaryCoverage?.isMedicaid,
      withCallIn,
      true,
      admin,
    ),
    initExpanded: true,
    name: 'Primary Coverage',
  }
}
